import { atom } from "jotai"
import type { Rect } from "@/lib/ai/detection/face-detection"

export interface PeopleFaceBox {
	personIndex: number
	rect: Rect
}

export const peopleFaceBoxesAtom = atom<PeopleFaceBox[]>([])
export const visiblePeopleFaceIndexesAtom = atom<number[]>([])
export const selectedPeopleFaceIndexAtom = atom<number | null>(null)
export const hoveredPeopleFaceIndexAtom = atom<number | null>(null)
